import React from "react";
import UserWebView from "./ViewItems/UserWebView";
import StaffWebView from "./ViewItems/StaffWebView";

const UsersList = (props) => {
  const {
    users,
    action,
    deleteUserPending,
    editUserPending,
    onDeleteUser,
    onRestoreUser,
    currentUrl,
    onChangeUserActive,
  } = props;
  const rights = {
    user: 0,
    manager: 1,
    "booking-manager": 1,
    "manager-location": 1,
    "garage-staff": 1,
    mediator: 1,
    admin: 2,
  };
  return (
    <>
      <div className="off-canvas-wrapper">
        <div
          id="inb-c-main-users"
          className="inb-c-listing off-canvas-content"
          data-off-canvas-content=""
        >
          {users.map((user, index) => {
            switch (action) {
              case "users":
                return (
                  <>
                    <UserWebView
                      user={user}
                      index={index}
                      deleteUserPending={deleteUserPending}
                      editUserPending={editUserPending}
                      onDeleteUser={onDeleteUser}
                      onRestoreUser={onRestoreUser}
                      currentUrl={currentUrl}
                      rights={rights}
                      onChangeUserActive={onChangeUserActive}
                      action={action}
                    />
                  </>
                );
              case "staff":
                return (
                  <>
                    <StaffWebView
                      user={user}
                      index={index}
                      deleteUserPending={deleteUserPending}
                      onDeleteUser={onDeleteUser}
                      onRestoreUser={onRestoreUser}
                      currentUrl={currentUrl}
                      rights={rights}
                      onChangeUserActive={onChangeUserActive}
                      action={action}
                    />
                  </>
                );
            }
          })}
        </div>
      </div>
    </>
  );
};

export default UsersList;
